import React from "react";

import {
	EventContentTabs,
	EventLiveWidget,
	EventFullInfoHeader,
} from "@features/offer/desktop/event";

export function EventFullInfo() {
	return (
		<div className="event__body">
			<EventFullInfoHeader />
			<EventLiveWidget />
			<EventContentTabs />
		</div>
	);
}
